export default "__VITE_ASSET__fmmGcduk__"